import React from "react";
import { StepLabel, StepStatus, Step } from "./Step";

interface Props {
  steps: Array<StepLabel>;
  stepIndex: number;
}

interface StepWithStatus {
  step: StepLabel;
  status: StepStatus;
  key: string;
}

export const StepIndicator = (props: Props) => {
  const stepsWithStatus: Array<StepWithStatus> = [];
  for (let i = 0; i < props.steps.length; i++) {
    const step = props.steps[i];
    const status =
      i > props.stepIndex
        ? StepStatus.Completed
        : i === props.stepIndex
        ? StepStatus.Current
        : StepStatus.Pending;
    const key = `${i}-${step.label.toLowerCase().replace(/[^a-z]/, "-")}`;
    stepsWithStatus.push({ step, status, key });
  }

  return (
    <div role="group" aria-label="progress">
      <ol className="list-unstyled step-indicator step-indicator-horizontal">
        {stepsWithStatus.map((sws) => (
          <Step key={sws.key} step={sws.step} status={sws.status} />
        ))}
      </ol>
    </div>
  );
};
